(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.initHoverMenus();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => {
        if (typeof disclosure.close === 'function') disclosure.close();
      });
    }

    closeSearchModal() {
      if (this.searchModal === undefined) {
        this.searchModal = this.header.querySelector('details-modal');
      }
      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }
    }

    initHoverMenus() {
      if (!window.matchMedia('(min-width: 990px)').matches) return;
      if (!window.matchMedia('(hover: hover)').matches) return;

      const pageLinks = {
        'HeaderMenu-for-him': '/pages/for-him',
        'HeaderMenu-for-her': '/pages/for-her',
      };

      const menuDetails = this.header.querySelectorAll('.header__inline-menu details');

      menuDetails.forEach((details) => {
        const summary = details.querySelector('summary');
        if (!summary) return;

        const link = pageLinks[summary.id];
        if (link) summary.dataset.link = link;

        details.addEventListener('mouseenter', () => {
          details.setAttribute('open', '');
        });

        details.addEventListener('mouseleave', () => {
          details.removeAttribute('open');
        });

        summary.addEventListener('click', (e) => {
          const target = summary.dataset.link;
          if (!target) return;
          e.preventDefault();
          e.stopPropagation();
          window.location.href = target;
        });
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var roots = document.querySelectorAll('[data-su-post]');
  if (!roots.length) return;

  Array.prototype.forEach.call(roots, function (root) {
    if (root.dataset.suReady) return;
    root.dataset.suReady = '1';

    var form = root.querySelector('[data-su-form]');
    var consult = root.querySelector('[data-su-consult]');
    var body = root.querySelector('[data-su-consult-body]');
    var done = root.querySelector('[data-su-done]');
    var live = root.querySelector('[data-su-live]');
    var bar = root.querySelector('[data-su-bar]');
    var fill = root.querySelector('[data-su-progress-fill]');
    var rte = root.querySelector('[data-su-rte]');

    var track = root.querySelector('.su-card') || rte;
    var rail = root.querySelector('[data-su-rail]');
    var handle = root.dataset.articleHandle || '';
    var doneKey = 'su_lead_' + handle;

    function measureHeader() {
      var header = document.querySelector('.section-header, header.header-wrapper, #shopify-section-header, body > header');
      var pinned = false;
      var h = 0;
      if (header) {
        var pos = window.getComputedStyle(header).position;
        pinned = pos === 'fixed' || pos === 'sticky';
        h = header.getBoundingClientRect().height;
      }
      var top = (pinned && h > 0 && h < 220) ? Math.round(h + 20) : 20;
      root.style.setProperty('--su-sticky-top', top + 'px');
    }
    measureHeader();
    window.addEventListener('resize', measureHeader, { passive: true });

    var railInner = root.querySelector('[data-su-rail-inner]');
    function measureRail() {
      if (!railInner) return;

      if (window.innerWidth < 990) { root.style.removeProperty('--su-rail-top'); return; }
      var stickyTop = parseInt(window.getComputedStyle(root).getPropertyValue('--su-sticky-top'), 10) || 20;
      var railH = railInner.getBoundingClientRect().height;
      var room = window.innerHeight - stickyTop - 16;
      var top = railH <= room ? stickyTop : Math.round(window.innerHeight - railH - 16);
      root.style.setProperty('--su-rail-top', top + 'px');
    }

    function unblockSticky() {
      if (!railInner) return;
      if (!window.CSS || !CSS.supports || !CSS.supports('overflow', 'clip')) return;
      var node = railInner.parentNode;
      var fixed = [];
      while (node && node.nodeType === 1 && node !== document.documentElement) {
        var cs = window.getComputedStyle(node);
        var hit = false;
        if (cs.overflowX === 'hidden') { node.style.overflowX = 'clip'; hit = true; }
        if (cs.overflowY === 'hidden') { node.style.overflowY = 'clip'; hit = true; }
        if (hit) fixed.push(node.tagName.toLowerCase() + (node.id ? '#' + node.id : '') + (node.className && typeof node.className === 'string' ? '.' + node.className.trim().split(/\s+/).join('.') : ''));
        node = node.parentNode;
      }
      if (fixed.length) console.info('[su-article] sticky rail: switched overflow hidden to clip on', fixed.join(', '));
    }
    unblockSticky();

    measureRail();
    window.addEventListener('resize', measureRail, { passive: true });

    window.addEventListener('load', measureRail);
    if (window.ResizeObserver && railInner) new ResizeObserver(measureRail).observe(railInner);

    if (fill) {
      var tick = function () {
        var box = track ? track.getBoundingClientRect() : null;
        if (!box) return;
        var total = box.height - window.innerHeight;
        var seen = -box.top;
        var pct = total > 0 ? Math.min(1, Math.max(0, seen / total)) : 0;
        fill.style.width = (pct * 100).toFixed(2) + '%';
      };
      window.addEventListener('scroll', tick, { passive: true });
      window.addEventListener('resize', tick, { passive: true });
      tick();
    }

    function splitFrom(host, anchor) {
      var tail = document.createElement('div');
      tail.className = 'su-rte su-rte--tail';
      var node = anchor;
      while (node) {
        var next = node.nextSibling;
        tail.appendChild(node);
        node = next;
      }
      host.parentNode.insertBefore(tail, host.nextSibling);
      return tail;
    }

    function directChildren(host, sel) {
      return Array.prototype.filter.call(host.children, function (el) {
        return el.matches(sel);
      });
    }

    var formula = root.querySelector('[data-su-formula]');
    if (formula && rte) {
      var faqAt = directChildren(rte, '.faq-section')[0];
      if (!faqAt) {
        faqAt = directChildren(rte, 'h2').filter(function (h) {
          return /frequently asked|^faqs?\b/i.test(h.textContent.trim());
        })[0];
      }
      if (faqAt) {
        var faqTail = splitFrom(rte, faqAt);
        rte.parentNode.insertBefore(formula, faqTail);
      }
    }

    if (bar && consult) {
      var barBtn = root.querySelector('[data-su-bar-btn]');
      var at = parseInt(root.dataset.barAt || '22', 10) / 100;

      var toggleBar = function () {
        if (sessionStorage.getItem(doneKey)) { bar.classList.remove('is-up'); return; }
        var box = track ? track.getBoundingClientRect() : null;
        if (!box) return;
        var passed = -box.top > box.height * at;
        var cardBox = consult.getBoundingClientRect();
        var cardVisible = cardBox.top < window.innerHeight - 80 && cardBox.bottom > 80;
        if (passed && !cardVisible) {
          bar.hidden = false;
          bar.classList.add('is-up');
        } else {
          bar.classList.remove('is-up');
        }
      };
      window.addEventListener('scroll', toggleBar, { passive: true });
      window.addEventListener('resize', toggleBar, { passive: true });
      toggleBar();

      if (barBtn) {
        barBtn.addEventListener('click', function () {
          consult.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var first = consult.querySelector('input[name="name"]');
          if (first) window.setTimeout(function () { first.focus({ preventScroll: true }); }, 420);
        });
      }
    }

    if (!form) return;

    try {
      if (sessionStorage.getItem(doneKey)) showDone();
    } catch (e) {  }

    var nameEl = form.querySelector('input[name="name"]');
    var phoneEl = form.querySelector('input[name="phone"]');
    var topicEl = form.querySelector('[name="topic"]');
    var hpEl = form.querySelector('input[name="city_confirm"]');
    var btn = form.querySelector('[data-su-submit]');
    var btnLabel = form.querySelector('[data-su-btn-label]');
    var sending = false;

    function tenDigits(raw) {
      var v = String(raw).replace(/\D/g, '').replace(/^0+/, '');
      if (v.length > 10 && v.indexOf('91') === 0) v = v.slice(2);
      return v.slice(0, 10);
    }

    phoneEl.addEventListener('input', function () {
      var before = phoneEl.value;
      var after = tenDigits(before);
      if (after === before) return;
      var caret = phoneEl.selectionStart;
      phoneEl.value = after;

      var moved = Math.max(0, caret - (before.length - after.length));
      try { phoneEl.setSelectionRange(moved, moved); } catch (e) {}
    });

    function fieldOf(el) { return el.closest('.su-field'); }

    function setErr(el, message) {
      var wrap = fieldOf(el);
      var slot = wrap.querySelector('[data-su-err]');
      if (message) {
        wrap.classList.add('is-bad');
        el.setAttribute('aria-invalid', 'true');
        slot.textContent = message;
      } else {
        wrap.classList.remove('is-bad');
        el.removeAttribute('aria-invalid');
        slot.textContent = '';
      }
      return !message;
    }

    function checkName() {
      var v = nameEl.value.trim();
      return setErr(nameEl, v.length < 2 ? 'Enter your name' : '');
    }
    function checkPhone() {
      var v = tenDigits(phoneEl.value);
      if (v.length < 10) return setErr(phoneEl, 'Enter all 10 digits');
      if (!/^[6-9]/.test(v)) return setErr(phoneEl, 'Indian mobile numbers start with 6, 7, 8 or 9');
      return setErr(phoneEl, '');
    }

    nameEl.addEventListener('blur', checkName);
    phoneEl.addEventListener('blur', checkPhone);

    function attribution() {
      try {
        if (window.SehatUpAttribution && window.SehatUpAttribution.fields) {
          return window.SehatUpAttribution.fields();
        }
        var f = JSON.parse(localStorage.getItem('sehatup_attr_first') || 'null') || {};
        var l = JSON.parse(localStorage.getItem('sehatup_attr_last') || 'null') || f;
        return {
          traffic_source: f.source || 'direct',
          utm_source: f.utm_source || '',
          utm_medium: f.utm_medium || '',
          utm_campaign: f.utm_campaign || '',
          utm_content: f.utm_content || '',
          utm_term: f.utm_term || '',
          landing_page: f.landing_page || '',
          referrer: f.referrer || '',
          gclid: f.gclid || '',
          fbclid: f.fbclid || '',
          first_seen_at: f.at || '',
          last_traffic_source: l.source || '',
          last_utm_campaign: l.utm_campaign || ''
        };
      } catch (e) { return {}; }
    }

    function submitLead(payload) {
      var url = root.dataset.endpoint;
      if (!url) {

        if (window.console) console.warn('[su-lead] no endpoint configured, lead not sent', payload);
        return Promise.resolve({ skipped: true });
      }
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
        redirect: 'follow'
      }).then(function (r) {
        if (!r.ok) throw new Error('lead endpoint returned ' + r.status);
        return r.json().catch(function () { return {}; });
      }).then(function (data) {

        if (data && data.ok === false) throw new Error(data.error || 'endpoint refused the lead');
        return data;
      });
    }

    function showDone() {
      if (body) body.hidden = true;
      if (done) done.hidden = false;
      if (bar) bar.classList.remove('is-up');
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (sending) return;

      if (hpEl && hpEl.value) { showDone(); return; }

      var ok = checkName();
      ok = checkPhone() && ok;
      if (!ok) {
        var bad = form.querySelector('.is-bad .su-input');
        if (bad) bad.focus();
        return;
      }

      sending = true;
      form.classList.add('is-busy');
      form.setAttribute('aria-busy', 'true');
      btn.disabled = true;
      if (btnLabel) btnLabel.textContent = 'Sending';
      if (live) live.textContent = 'Sending your request';

      var payload = {
        token: root.dataset.token || '',
        name: nameEl.value.trim(),
        phone: '+91' + tenDigits(phoneEl.value),
        topic: topicEl ? topicEl.value : '',
        source: 'blog_article',
        sheet: root.dataset.collection,
        article_handle: handle,
        article_title: root.dataset.articleTitle,
        page_url: location.href,
        page_referrer: document.referrer,
        submitted_at: new Date().toISOString()
      };
      var attr = attribution();
      for (var k in attr) { if (!(k in payload)) payload[k] = attr[k]; }

      submitLead(payload).then(function () {
        try { sessionStorage.setItem(doneKey, '1'); } catch (e2) {}
        if (live) live.textContent = 'Request received. A doctor will call you back.';
        showDone();
      }).catch(function (err) {
        sending = false;
        form.classList.remove('is-busy');
        form.removeAttribute('aria-busy');
        btn.disabled = false;
        if (btnLabel) btnLabel.textContent = 'Try again';
        if (live) live.textContent = 'That did not send. Check your connection and try again.';
        if (window.console) console.warn('[su-lead]', err);
      });
    });
  });
})();

(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function slugify(text) {
    return text.toLowerCase().trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '') || 'section';
  }

  function flash(h) {
    var el = h.querySelector(':scope > .su-toc-mark');
    if (!el) {
      el = document.createElement('span');
      el.className = 'su-toc-mark';
      while (h.firstChild) el.appendChild(h.firstChild);
      h.appendChild(el);
    }
    el.classList.remove('su-toc-flash');
    void el.offsetWidth;
    el.classList.add('su-toc-flash');
    window.setTimeout(function () { el.classList.remove('su-toc-flash'); }, 2700);
  }

  function whenScrollSettles(cb) {
    if (reduceMotion) { cb(); return; }
    var fired = false;
    var run = function () { if (!fired) { fired = true; cb(); } };
    if ('onscrollend' in window) window.addEventListener('scrollend', run, { once: true });
    window.setTimeout(run, 900);
  }

  function build(root) {
    var toc = root.querySelector('[data-su-toc]');
    if (!toc || toc.dataset.suTocReady) return;
    toc.dataset.suTocReady = '1';

    var list = toc.querySelector('[data-su-toc-list]');
    var toggle = toc.querySelector('[data-su-toc-toggle]');
    var count = toc.querySelector('[data-su-toc-count]');
    var headings = Array.prototype.filter.call(root.querySelectorAll('.su-rte h2'), function (h) {
      return h.textContent.trim().length > 0;
    });
    if (headings.length < 2) return;

    var used = {};
    headings.forEach(function (h) {
      if (!h.id) {
        var base = slugify(h.textContent);
        var id = base;
        var n = 2;
        while (used[id] || document.getElementById(id)) { id = base + '-' + n++; }
        h.id = id;
      }
      used[h.id] = true;

      var li = document.createElement('li');
      var a = document.createElement('a');
      a.className = 'su-toc__link';
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim();
      a.addEventListener('click', function (e) {
        e.preventDefault();
        h.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + h.id);
        whenScrollSettles(function () {
          if (!h.hasAttribute('tabindex')) h.setAttribute('tabindex', '-1');
          h.focus({ preventScroll: true });
          flash(h);
        });
      });
      li.appendChild(a);
      list.appendChild(li);
    });

    if (count) count.textContent = headings.length + ' sections';
    toggle.addEventListener('click', function () {
      toggle.setAttribute('aria-expanded', toggle.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
    });
    toc.hidden = false;
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-su-post]'), build);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

  } catch(e) { console.error(e); }
})();
})();
